import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { QueryClient } from 'react-query';
import { authnClient } from '@frontend/auth';
import { PortalUser } from '@frontend/auth-helpers';
import { NotFound } from '../../components';

const Root = () => {
  return (
    <div>
      <Outlet />
      <TanStackRouterDevtools />
    </div>
  );
};

export const Route = createRootRouteWithContext<{
  auth: typeof authnClient;
  queryClient: QueryClient;
  user: PortalUser | undefined;
}>()({
  component: Root,
  notFoundComponent: () => <NotFound />,
});
